import _styled from "@emotion/styled-base";
export var Title = _styled("div", {
  target: "ehuvnqh0",
  label: "Title"
})(function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return theme.text[variant];
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91c2VyL2NvbW1vbi9UaXRsZS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRStCIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy91c2VyL2NvbW1vbi9UaXRsZS5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IFRpdGxlID0gc3R5bGVkLmRpdmBcblx0JHsoeyB0aGVtZSwgdmFyaWFudCB9KSA9PiB0aGVtZS50ZXh0W3ZhcmlhbnRdfTtcbmBcblxuVGl0bGUuZGVmYXVsdFByb3BzID0ge1xuXHR2YXJpYW50OiAnZGlzcGxheTEnLFxufVxuIl19 */"));
Title.defaultProps = {
  variant: 'display1'
};